
//@ts-nocheck

import { create } from 'zustand';
import { persist } from 'zustand/middleware'

export const useAuthValidator = create()(persist((set) => ({
    user: {},
    partner:{},
    menus: [],
    handleAuthenticate: (value) => set(() => {
        return { isAuthenticate: value };
    }),
    handleUserDetails: (value) => set(() => {
        return { user: value };
    }),
    handleMenus: (value) => set(() => {
        return { menus: value };
    }),
    handlePartner: (value) => set(() => {
        return { partner: value };
    }),
}),
    {
        name: "auth-storage",
        getStorage: () => localStorage,
    }))